module.exports = __webpack_public_path__ + "img/right_arrow_black.69ef0922.svg";